import { addDays, intervalToDuration } from 'date-fns';
import pluralize from 'pluralize';
import helperStatus from '@/helpers/status';

export function minStartDate(): Date {
  return addDays(new Date(), 1);
}

export function maxStartDate(): Date {
  return addDays(new Date(), 90);
}

export function status(hasError: Boolean, startDate: Date): helperStatus {
  if (!hasError || startDate) {
    return helperStatus.Neutral;
  }
  return helperStatus.Error;
}

export function helperText(hasError: Boolean, startDate: Date): String {
  return hasError && !startDate ? 'This field is required.' : '';
}

export function duration(start: Date, end: Date): string {
  const d = intervalToDuration({ start, end });
  const pieces: string[] = [];

  if (d.days && d.days > 0) {
    pieces.push(pluralize('day', d.days, true));
  }

  if (d.hours && d.hours > 0) {
    pieces.push(pluralize('hour', d.hours, true));
  }

  if (d.minutes && d.minutes > 0) {
    pieces.push(pluralize('minute', d.minutes, true));
  }

  return pieces.join(', ');
}
